<template>
  <div>
    <NoticeBar scrollable left-icon="volume-o" class="notice-container">
      <span class="item" v-for="(item,index) in lth" :key="item">尾号{{renderPhoneNo()}}，已成功提现 <i>¥{{ amtList[index] | amount}}</i></span>
    </NoticeBar>
    <img src="../images/img_liangbu@2x.png" width="100%" alt="">
  </div>
</template>

<script>

import { NoticeBar } from 'vant'
export default {
  data () {
    return {
      amtList: [],
      lth: 30 // 数据条数
    }
  },
  components: {
    NoticeBar
  },
  mounted () {
    for (let index = 0; index < this.lth; index++) {
      if (index % 3 === 0) {
        this.amtList.push(50000)
      } else {
        const min = 8000
        const max = 50000
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min
        const randomMultiple = Math.ceil(randomNumber / 1000) * 1000
        this.amtList.push(randomMultiple)
      }
    }
  },
  methods: {
    renderPhoneNo () {
      return Math.floor(Math.random() * 10000)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

  .notice-container {
    background: #444444;
    height: 60px;
    line-height: 60px;
    color: #fff;
    /deep/.van-icon {
      font-size: 30px;
    }
    .item {
      padding: 0 20px;
      font-size: 24px;
      padding-top: 5px;
      display: inline-block;
      i {
        color: rgb(217, 171, 132);
        font-style: normal;
      }
    }
  }
</style>